export function LoadingPaymentForm() {
  return (
    <div className="h-16 bg-gray-200 rounded-md dark:bg-gray-300  w-full mb-4 animate-pulse"></div>
  );
}
